(ns ncr.fragment.core
  (:require
   [cljs.core.async :refer-macros [go] :refer [<!]]
   [clojure.core.match :refer [match]]
   [lambdaisland.glogi :as log]
   [uix.core.alpha :as uix]
   [ncr.etc.util :as u]
   [ncr.backend :as b]
   [ncr.widgets.core :as w]
   [ncr.widgets.fragment :as wf]
   [ncr.etc.pf :as pf]
   [ncr.etc.pubsub :as ps]
   [ncr.me :as me]
   [ncr.push :as push]
   [ncr.navigate :as n]
   [ncr.search.item :as fragment-search-item]
   [ncr.fragment.label :as fragment-label]
   [ncr.fragment.folder :as fragment-folder]
   [ncr.fragment.access :as fragment-access]
   [ncr.fragment.common :as fragment-common]
   [ncr.fragment.props :as fragment-props]
   [ncr.fragment.attachment-markup :as am]
   [ncr.fragment-types.attachments-editor :as attachments-editor]
   [ncr.fragment.share-send :as share-send]
   [ncr.widgets.datev]
   [ncr.eventlog]
   [ncr.amplitude :as amp]
   [ncr.etc.profile :as profile]))

(defn- use-prop-drawer []
  (let
    [pspec [:local "ui/preferences/prop-drawer"]
     default {:expanded? true}
     {:keys [expanded? width]} @(profile/use-profile pspec default)
     update-fn (partial profile/swap-profile! pspec default assoc)]
    {:expanded? expanded?
     :toggle-expanded? #(update-fn :expanded? (not expanded?))
     :width width
     :set-width #(update-fn :width %)}))

(defn- c-toolbar [{:keys [prop-drawer]} {:keys [fragment]}]
  (let
    [no-fragment? (nil? fragment)
     {:keys [promotedHint writableHint ownerWritableHint folder id revoked]} fragment
     me (uix/context me/*context*)
     in-trash? (= folder (get (me/trash-folder me) :id))

     handler
     (fn h
       ([action-fn]
        (h action-fn (fn [] (ps/pub! [:fragment/load false]))))
       ([action-fn ok-fn]
        (fn [_]
          (go
            (u/when-ok [_ (<! (action-fn me [fragment]))]
              (ok-fn))))))]

    [pf/c-toolbar {:class :ncr-u-border-bottom}
     [pf/c-toolbar-content
      [pf/c-toolbar-group {:variant :icon-button-group}
       [w/c-toolbar-button
        {:icon
         :arrow-left
         :on-click
         (fn [_]
           (amp/navigate! {"Origin" "Fragment" "Destination" "<back>"})
           (n/back!))
         :tooltip "Back"}]

       [w/c-toolbar-button
        {:icon :reload
         :on-click #(ps/pub! [:fragment/load true])
         :tooltip "Reload"}]]

      [pf/c-toolbar-group {:variant :icon-button-group}
       [w/c-toolbar-button
        {:icon :folder-move-outline
         :is-disabled (or no-fragment? promotedHint)
         :on-click (handler fragment-folder/!move)
         :tooltip "Move to another folder"}]

       [w/c-toolbar-button
        {:icon :send-outline
         :is-disabled (or no-fragment? promotedHint)
         :on-click (handler share-send/!send n/back! #_[:navigation/back])
         :tooltip "Send to another user"}]


       (let [{:keys [status allowed]} (get-in me [:caps :datev])]
         (when (= :connected status)
           [w/c-toolbar-button
            {:icon :cloud-arrow-up-outline
             :is-disabled (not allowed)
             :on-click (handler ncr.widgets.datev/schedule-upload!)
             :tooltip "Upload to DATEV"}]))

       [w/c-toolbar-button
        {:icon :tag-multiple-outline
         :is-disabled (or no-fragment? (not writableHint) in-trash?)
         :on-click (handler fragment-label/!edit-labels)
         :tooltip "Labels"}]

       [w/c-toolbar-button
        {:icon :pencil-outline
         :is-disabled (or no-fragment? (not writableHint) in-trash?)
         :on-click (handler fragment-common/!fragment-edit)
         :tooltip "Edit fragment"}]

       [w/c-toolbar-button
        {:icon :history
         :on-click #(ncr.eventlog/!show :reference id)
         :tooltip "History"}]]

      [pf/c-toolbar-group {:variant :icon-button-group}
       [w/c-toolbar-button
        {:icon :account-multiple-outline
         :is-disabled (or no-fragment? (not promotedHint) (not ownerWritableHint))
         :on-click (handler fragment-access/!permissions)
         :tooltip "Manage permissions"}]

       [wf/c-promote
        (or no-fragment? (not writableHint) promotedHint in-trash?)
        (handler fragment-access/!promote)
        (handler fragment-access/!quick-promote)]]

      [pf/c-toolbar-group {:variant :button-group}
       (cond
         (some? revoked)
         [w/c-toolbar-button
          {:icon :rocket-launch-outline
           :is-disabled (not writableHint)
           :on-click (handler fragment-common/!quick-unrevoke)
           :tooltip "Return to Accepted"}]

         promotedHint
         [w/c-toolbar-button
          {:icon :trash-can-outline
           :is-disabled (not writableHint)
           :on-click (handler fragment-common/!quick-revoke)
           :tooltip "Revoke fragment"}]

         :else
         [w/c-toolbar-button
          {:icon :trash-can-outline
           :is-disabled (or no-fragment? (not writableHint) in-trash?)
           :on-click (handler fragment-folder/!move-to-trash)
           :tooltip "Delete fragment (move to Trash folder)"}])]

      [pf/c-toolbar-group {:variant :button-group :alignment {:default :align-right}}
       [w/c-toolbar-button
        {:icon :dock-right
         :is-disabled no-fragment?
         :on-click (:toggle-expanded? prop-drawer)
         :tooltip "Toggle properties panel"}]]]]))

(defn c-fragment-data [{:keys [me]} {:keys [fragment properties]}]
  [pf/c-panel {:class :ncr-u-border-bottom}
   [pf/c-panel-main
    [pf/c-panel-main-body {:class :pf-u-py-sm}
     [fragment-search-item/c-item-body
      {:me me
       :track-origin "Fragment"}
      (assoc fragment :properties properties)]]]])

(defn- c-fragment-body [{:keys [fragment] :as model} attachment-id prop-drawer]
  (let [{:keys [expanded? width set-width]} prop-drawer]
    [pf/c-drawer {:is-expanded expanded? :is-inline true}
     [pf/c-drawer-content
      {:panel-content
       [fragment-props/c-properties-drawer
        {:model model
         :width width
         :set-width set-width}]}
      [pf/c-drawer-content-body
       [attachments-editor/c-body* {} fragment attachment-id]]]]))

(defn- xform-attachments [atts]
  (when atts
    (->> atts
      (mapv #(update % :metadata u/transit-read))
      (mapv #(update % :auxdata u/transit-read)))))

(defn c-fragment [{:keys [id slug attachment-id] :as route-data}]
  (let
    [state
     (ps/sub-reducer-map! {}
       {::state
        (fn [_ state]
          state)

        :fragment/properties-update
        (fn [state update-fn]
          (match state
            {:status :loaded :data {:properties _}}
            (update-in state [:data :properties] update-fn)
            _
            state))

        :fragment/load
        (fn load-fragment
          ([state progress?] (load-fragment state progress? nil))
          ([state progress? callback]
           (go
             (u/when-fail
               [error
                (u/error-m
                  [{fragment :fragment_ properties :properties}
                   (<!
                     (b/!multi-query
                       {:fragment_
                        [:fragment_load {:reference id}
                         [:id
                          :name :description :labels :folder :writableHint :ownerWritableHint :promotedHint :revoked
                          :readACL :writeACL :owner :creator [:referenceTimestamps [:created]]
                          [:attachments [:id :fileName :length :mimeType :lastModified :deleted :immutable :metadata :auxdata]]]]

                        :properties
                        [:properties_load {:reference id}]}))

                   fragment
                   (-> fragment
                     (update-in [:referenceTimestamps :created]
                       b/parse-utc-date-time)
                     (update :attachments xform-attachments))

                   properties (u/transit-read properties)]
                  (let [slug' (-> fragment :name fragment-common/fragment-name->slug)]
                    (when (not= slug' slug)
                      (n/replace-state!
                        (:name route-data)
                        (assoc route-data :slug slug'))))

                  (ps/pub! [::state {:status :loaded :data {:fragment fragment :properties properties}}])
                  (when callback (callback)))]

               (do
                 (ps/pub! [::state {:status :error :reason error}])
                 (log/error :error error)
                 (when callback (callback)))))
           (if progress?
             {:status :progress} state)))})
     me (uix/context me/*context*)
     prop-drawer (use-prop-drawer)]

    (push/use-push!
      (fn [message]
        (match message
          {:domain :reference :event-type :update :domain-id id}
          (ps/pub! [:fragment/load false])

          _
          nil)))

    (uix/with-effect [id]
      (ps/pub! [:fragment/load true]))

    (uix/with-effect [@state]
      (u/set-page-title
        (-> @state :data :fragment :name)
        (-> me :cluster :name)))

    (match @state
      {:status :progress}
      [w/c-empty-progress "Loading..."]

      {:status :loaded :data data}
      [:<>
       [pf/c-page-section {:class :pf-u-p-0}
        [c-toolbar {:prop-drawer prop-drawer} data]]

       [pf/c-page-section {:class :pf-u-p-0}
        [c-fragment-data {:me me} data]]

       [pf/c-page-section {:class :pf-u-p-0 :variant :light :id :ncr-c-fragment-body}
        [c-fragment-body data attachment-id prop-drawer]]]

      {:status :error}
      [:<>
       [pf/c-page-section {:class :pf-u-p-0}
        [c-toolbar {:prop-drawer prop-drawer} {}]]
       [pf/c-page-section
        {:class [:pf-u-p-0]
         :variant :light
         :style {:position :relative}
         :aria-label "Fragment not found"}
        [pf/c-empty-state
         [pf/c-empty-state-icon
          {:variant :container
           :component [w/c-mdi-icon {:icon :feature-search-outline}]}]
         [pf/c-title {:heading-level :h4 :size :lg} "Fragment not found"]
         [pf/c-empty-state-body "Do you have required permissions?"]
         [pf/c-button
          {:variant :primary
           :on-click #(ps/pub! [:fragment/load true])}
          "Try again"]

         [pf/c-empty-state-secondary-actions
          [pf/c-button
           {:variant :link
            :on-click #(n/push-search! "")}
           "Back to search"]]]]]
      _
      nil)))
